import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import styles from './index.module.sass'
import routes from '../../config/routes'

class Atemption extends Component {
  navHandler = index => {
    this.props.history.push(routes[index].path)
  }

  render() {
    const { pages = [] } = this.props
    const content =
      pages.find(({ path }) => path === window.location.pathname) || {}
    const { atemption = {} } = content

    const index = routes.findIndex(
      ({ path }) => this.props.location.pathname === path
    )
    const { atemption: staticAtemption } = routes[index] || {}

    if (!staticAtemption) return null

    return (
      <div id="atemtion" className={styles.wrapper + ' animated zoomIn'}>
        <div
          className={styles.content + ' animated zoomIn'}
          dangerouslySetInnerHTML={{
            __html: atemption.html ? atemption.html : staticAtemption.html,
          }}
        />
      </div>
    )
  }
}

export default withRouter(connect(state => state)(Atemption))
